import {h, Fragment} from "preact"
import Product from './Product'
import { useAppStateSelector } from '@nosto/preact'

export default function Products() {
    const { products, loading } = useAppStateSelector((state) => ({
        products: state.response.products,
        loading: state.loading,
    }))

    return (
        <div class="grid grid--uniform grid--collection small--grid--flush">
            {products.hits.map((hit, index) => {
                return <Product product={hit} key={hit.productId || index} />
            })}
        </div>
    )
}
